"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createReduce = _interopRequireDefault(require("./_createReduce.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
var _default = exports.default = (0, _createReduce.default)(1);